module.exports = __webpack_public_path__ + "static/media/success_3.c7504b9f.gif";